import React from 'react';
import { Label } from 'reactstrap';
import { compose, withHandlers } from 'recompose';
import { ModalHeader, ModalBody, ModalFooter } from '../../modal-helpers';
import Button from '../../../buttons/DeprecatedButton/DeprecatedButton';
import './NoLinkedAdAccountModal.scss';

type Props = {
  onModalSubmit: () => void;
};

const onModalSubmit =
  ({ closeModal }) =>
  () => {
    closeModal();
  };

const enhance = compose<Props, Props>(withHandlers({ onModalSubmit }));

const NoLinkedAdAccountModal = (props: Props) => {
  const { onModalSubmit } = props;

  return (
    <div className="ad-audience-no-linked-account-modal">
      <ModalHeader className="ad-audience-no-linked-account-modal__header">
        No Linked Ad Account
      </ModalHeader>
      <ModalBody className="ad-audience-no-linked-account-modal__body">
        <Label className="ad-audience-no-linked-account-modal__input-wrapper">
          <div className="ad-audience-no-linked-account-modal__input-with-error">
            <p>
              Looks like you haven't linked an Ad Account to this Facebook Page
              in Customers.ai yet.
            </p>
            <p>
              Learn how to set this up{' '}
              <a
                href="https://customers.ai/help/l/en/article/otyde6hupt"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              !
            </p>
          </div>
        </Label>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onModalSubmit}>OК</Button>
      </ModalFooter>
    </div>
  );
};

export default enhance(NoLinkedAdAccountModal);
